
namespace Gamification.Gamification {
    export class AssetEsperienzeRisorseColumns {
        static columnsKey = 'Gamification.AssetEsperienzeRisorse';
    }
}